import { render, staticRenderFns } from "./CompanyPopup.vue?vue&type=template&id=4fe4afb0"
import script from "./CompanyPopup.vue?vue&type=script&lang=ts"
export * from "./CompanyPopup.vue?vue&type=script&lang=ts"
import style0 from "./CompanyPopup.vue?vue&type=style&index=0&id=4fe4afb0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports